import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseComponent } from '@modules/components/base-component';
import { TableColumns } from '@smartera/core';
import { UtilityService } from '@core/services/utility.service';

@Component({
	// tslint:disable-next-line: component-selector
	selector: 'dash-table',
	templateUrl: './dash-table.component.html',
	styleUrls: ['./dash-table.component.scss'],
	standalone: false,
})
export class DashTableComponent extends BaseComponent implements OnInit {
	@Input() columns: TableColumns<any>;
	@Input() title: string;
	@Input() sortField: string;
	@Input() scrollable = false;
	@Input() scrollHeight: string;
	@Input() actionButtons = [];
	@Input() switchValue: boolean;
	@Input() switchButtonLabel: string;
	@Input() sortOrder: 'ASC' | 'DESC' = 'ASC';
	// @Input() isExcelToExport: boolean;

	@Input() columnWidth: string;

	@Input() set service(serv) {
		this.componentService = serv;
	}

	@Input() pagination: boolean;
	@Input() pageSize: number;
	@Input() id: string;

	@Output() action = new EventEmitter();
	@Output() changeSwitch = new EventEmitter();
	public rowsPerPage = [5, 10, 25, 50, 100, 500];

	initStarted = false;
	isLazy = false;

	constructor(utilServ: UtilityService) {
		super(null, utilServ);

		this.searchForm = this.builder.group({
			// TODO ☕☕
		});
	}

	// eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
	ngOnInit() {}

	getPageWholeData() {
		this.getPageData();
	}

	refreshData(searchArgs: any = {}) {
		this.searchObject = searchArgs;
		this.pageNumber = 0;
		return this.getPageData();
	}

	setInitSearchData(searchData: any) {
		this.searchObject = searchData;
		this.initStarted = true;
		this.isLazy = true;
	}

	invokeAction(id, arg) {
		this.action.emit({ id, arg });
	}

	onChangeSwitch(switchId: any) {
		this.changeSwitch.emit(switchId);
	}
}
